import { Stack } from '@mui/material'
import { Membership } from '~/common/generated/apollo-operations'
import { UserAvatar } from '../../users/UserAvatar'

interface UserArrayTableCellProps {
  users: Pick<Membership, 'id' | 'firstName' | 'lastName' | 'email'>[]
}

/**
 * Renders table cell for a column of type ARRAY with inner type User
 */
export function UserArrayTableCell({ users }: UserArrayTableCellProps) {
  return (
    <Stack direction="row" spacing={1}>
      {users.map((user) => (
        <UserAvatar key={user.id} includeTooltip small user={user} />
      ))}
    </Stack>
  )
}
